import React from 'react';
import Icon from '@pushpay/icon';

const PlusIcon = props => {
  return /*#__PURE__*/React.createElement(Icon, Object.assign({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2 12c0 .69.56 1.25 1.25 1.25h7.292c.115 0 .208.093.208.208v7.292a1.25 1.25 0 002.5 0v-7.292c0-.115.093-.208.208-.208h7.292a1.25 1.25 0 000-2.5h-7.292a.208.208 0 01-.208-.208V3.25a1.25 1.25 0 00-2.5 0v7.292a.208.208 0 01-.208.208H3.25C2.56 10.75 2 11.31 2 12z",
    fill: "currentColor"
  }));
};

export default PlusIcon;